import { ROUTE_PATHS } from '../route-paths';

const reservedSegments = new Set(
  Object.values(ROUTE_PATHS)
    .map((path) => path.split('/')[1])
    .filter(
      (segment): segment is string =>
        Boolean(segment) && !segment.startsWith('$'),
    ),
);

export const getStoreRoutePath = (slug: string) =>
  reservedSegments.has(slug.toLowerCase())
    ? ROUTE_PATHS.LEGACY_STORE_FOLDER
    : ROUTE_PATHS.STORE_FOLDER;
